import { Fragment } from "react";
import { useTranslation } from "react-i18next";

import { useStore } from "../../hook-store/store";

import { 
  loginPageLink, 
  signupPageLink, 
  // kuraStorageLink
} from "../../App";

import { marks } from "../../utils/marks";

export default function AuthButtons() {

  const [t] = useTranslation("translation");

  const [store, dispatch] = useStore();
  const { isAuth } = store.uiStore;

  return (
    <Fragment>
      <div>
        <div>
          <a href={loginPageLink}>
            <button className="btnBase">
              {marks.signInMrak} {t('aboutAuth06', 'Login')}
            </button>
          </a>
          <span>, or </span>
          <a href={signupPageLink}>
            <button className="btnBase">
              {marks.userPlusMrak} {t('aboutAuth07', 'Signup')}
            </button>
          </a>
        </div>
      </div>
    </Fragment>
  );
}